const accordionStyles = {
  borderRadius: ({ shape }) => `${shape.radius.l} !important`,
  boxShadow: ({ palette }) => palette.shadow.s,

  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
};

export const getAccordionStyles = ({ isDeleted }) => ({
  ...accordionStyles,
  ...(isDeleted && {
    backgroundColor: ({ palette }) => palette.background.disabled,
    '& .MuiDivider-root': {
      borderColor: ({ palette }) => palette.border.input,
    },
  }),
});

export const accordionSummaryStyles = {
  width: '100%',
  padding: '12px',

  '&.Mui-expanded': {
    minHeight: 'auto !important',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '0 !important',
  },
};

export const summaryContentStyles = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '0 12px 0 0',
};

export const formWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
  minHeight: '176px',
};

export const reasonTitleWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const accordionDetailsStyles = {
  padding: '0 12px 12px 12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const reasonMetadataStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  width: '100%',
};

export const triggerFieldsStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '4px',
  width: '100%',
};

export const amountInputContainerStyles = {
  display: 'flex',
  gap: '12px',
  width: '100%',

  '& .MuiOutlinedInput-root.Mui-disabled input': {
    color: ({ palette }) => `${palette.text.placeholder} !important`,
    WebkitTextFillColor: ({ palette }) => `${palette.text.placeholder} !important`,
  },
};
